/*{ ------------------- Icons & Buttons ------------------------} */
import { LuSearch } from "react-icons/lu";
import RestartAltIcon from '@mui/icons-material/RestartAlt'

/*{ ------------------- import components ------------------------} */
import useBooking from "./hook/useBooking"
import FormField from '../../components/Common-components/form-input';
import TableHeadings from '../../components/Common-components/table-headings'
import { Pagination } from '../../components/Pagination';
import { Spinner } from '../../components/Common-components/spinner';
import useMuiCustom from '../../hooks/useMuiCustom';
import { useTranslation } from "react-i18next";
import SearchFilter from "../../components/Common-components/serchFillter";
import moment from "moment-timezone";
import { Navigate } from "react-router-dom";
import Modal from '../../components/PopUpModal'
import { Avatar } from "@mui/material";
import { imageBaseUrl } from "../../components/Constant";
export default function Booking() {
  const { t } = useTranslation();

  const { totalCount, controller, BookingTableHeader, BookingTabledata, handlePagination, bookigdata, handleOpenModal, handleClosedModal, openModal, BookingTableHeaderData, handleChangeFilter, Filter,
    HandleSearch,
    reset } = useBooking();
  const { SwitchButton } = useMuiCustom();


  return (

    <>

      <div className='container-fluid d-flex flex-column h-100'>
        <div className='px-2'>
          <SearchFilter
            disabled={Filter?.disable_button}
            handleSearch={HandleSearch}
            handleFilterInput={handleChangeFilter}
            value={Filter?.search}
            reset={reset}
          />
        </div>

        <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll px-2" style={{ height: "500px" }}>
          <table className="table cus-table">
            <TableHeadings TableHeadData={BookingTableHeader} controller={controller} setController={handlePagination} />
            <tbody>
              {bookigdata?.map((curr, index) => (
                <>
                  <tr>
                    <td>{controller.rowsPerPage * (controller.page - 1) + index + 1}</td>
                    <td className='blue-color cursor' onClick={() => handleOpenModal("viewBooking", curr)}>{curr?.bookingReferenceNumber}</td>
                    <td>{curr?.clientName}</td>
                    <td>{moment(curr?.dateOfBooking).format('DD-MM-YYYY')}</td>
                    <td>{moment(curr?.dateOfBooking).format('hh:mm A')}</td>
                    <td>
                      {/* OEVENT (super admin) offer: this vendor's part after its share of the discount, with the price before it */}
                      {curr?.vendorOfferShare ? <>
                        {curr.vendorOfferShare.amount}
                        <div className='font-12 gray-color'>
                          <del>{curr.vendorOfferShare.priceBeforeDiscount}</del> · {t('bookingOffer.discount')} {curr.vendorOfferShare.adminDiscount}
                        </div>
                      </> : curr?.finalTotal}
                    </td>
                    {/* <td style={{ color: "#55E47D", fontSize: "14px", fontWeight: "500px" }}>{curr?.status}</td> */}
                  </tr>
                  <tr className='default_tr_gap'></tr>
                </>
              ))}
            </tbody>
          </table>
          {!bookigdata?.length && <div className="text-center my-2 black-color">{`${t("tableTitle.noRecordFound")}`}</div>}
        </div>
        {
          totalCount > 10 &&
          <div>
            <Pagination count={totalCount} controller={controller} setController={handlePagination} />
          </div>
        }

      </div>
      <Modal
        className="p-0"
        size="xl"
        onHide={() => handleClosedModal('viewBooking')}
        show={openModal?.viewBooking}
        headerContent={<h5 className="m-0 black-color fw-6 font-15 text-center w-100">View Booking</h5>}
        bodyContent={
          <div >
            <div className="table-responsive custom_table  flex-fill mt-3 custom_scroll" >
              <table className="table cus-table">
                <TableHeadings TableHeadData={BookingTableHeaderData} />
                <tbody>
                  {openModal?.data?.services?.map((cur, index) => (
                    <tr key={cur.id || index} className='border'>
                      <td>{<Avatar src={`${imageBaseUrl}vendorServiceImg/thumbnail/${cur?.image}`} />}</td>
                      <td>{cur?.serviceName}</td>
                      <td>{cur?.price}</td>
                      <td>{cur?.quantity}</td>
                      <td>{cur?.finalPrice}</td>
                      <td>{cur?.status}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* OEVENT (super admin) offer: this vendor's part before the discount, its share of the discount and what the client paid */}
            {openModal?.data?.vendorOfferShare && <div className='d-flex justify-content-end px-3 pb-3 font-13'>
              <div className='border rounded-3 p-3' style={{ minWidth: 300 }}>
                <div className='d-flex justify-content-between mb-2'>
                  <span className='black-color fw-6'>{t('bookingOffer.couponApplied')}</span>
                  <span className='blue-color fw-6'>{openModal?.data?.adminOffer?.couponCode}</span>
                </div>
                <div className='d-flex justify-content-between mb-1'>
                  <span className='gray-color'>{t('bookingOffer.totalAmount')}</span>
                  <span className='black-color'>{openModal?.data?.vendorOfferShare?.priceBeforeDiscount} {t('tableTitle.currencysymbols')}</span>
                </div>
                <div className='d-flex justify-content-between mb-1'>
                  <span className='gray-color'>{t('bookingOffer.discount')}</span>
                  <span className='text-success fw-6'>- {openModal?.data?.vendorOfferShare?.adminDiscount} {t('tableTitle.currencysymbols')}</span>
                </div>
                <hr className='my-2' />
                <div className='d-flex justify-content-between fw-6'>
                  <span className='black-color'>{t('bookingOffer.finalPaidAmount')}</span>
                  <span className='blue-color'>{openModal?.data?.vendorOfferShare?.amount} {t('tableTitle.currencysymbols')}</span>
                </div>
              </div>
            </div>}

          </div>
        }
      />
    </>
  )
}
